import * as React from "react";
import { render } from "react-dom";

import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";

import { router5Middleware } from "redux-router5";
// import dotenv from "dotenv";
import registerServiceWorker from "register-service-worker";

import App from "modules/root/root-component";
import { rootReducer } from "modules/root/root-reducer";
import { rootSaga } from "modules/root/root-saga";
import { buildRouter } from "modules/routing/build-router";
import ReduxIntlProvider from "./modules/i18n/redux-intl-provider";
import { configureLocaleData, Locale } from "./modules/i18n/locale-config";

import * as ReactDatepicker from "react-datepicker";
import * as sv from "date-fns/locale/sv";
import * as Sentry from "@sentry/browser";

import devUtils from "modules/utils/dev-utils";

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN
  });
  Sentry.setTag("application", "OSD");
  console.log("Sentry initialized", process.env.REACT_APP_SENTRY_DSN);
}

// dotenv.config();
const identityFn = value => value;

const router = buildRouter();
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(sagaMiddleware, router5Middleware(router)),
    process.env.REACT_APP_ENV !== "production" &&
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : identityFn
  )
);

ReactDatepicker.registerLocale(Locale.SV.code, sv);
configureLocaleData();

router.start(() => {
  sagaMiddleware.run(rootSaga);

  render(
    <Provider store={store}>
      <ReduxIntlProvider>
        <App />
      </ReduxIntlProvider>
    </Provider>,
    document.getElementById("app-root")
  );
  registerServiceWorker();
});

if (process.env.REACT_APP_ENV !== "production") {
  devUtils.initialize();
}



// WEBPACK FOOTER //
// ./src/index.js